import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FormErrorsComponent } from 'src/app/components/form-errors/form-errors.component';
import { ProfessionalProfiles } from 'src/app/models/ProfessionalProfiles/ProfessionalProfiles';
import { ProfessionalProfilesService } from 'src/app/services/professional-profiles.service';



@Component({
  imports: [CommonModule, ReactiveFormsModule, FormErrorsComponent, MatDialogContent, MatDialogActions, MatDialogTitle],
  selector: 'app-professional-profiles-modal',
  templateUrl: './professional-profiles-modal.component.html',
  styleUrl: './professional-profiles-modal.component.css'
})
export class ProfessionalProfilesModalComponent implements OnInit{
  form: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<ProfessionalProfilesModalComponent>,
    public ProfessionalProfilesService: ProfessionalProfilesService,
    public _toastService: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any    
  ) {
    
    this.buildForm();

    if(this.data?.item){
      this.form.patchValue({...this.data?.item}); 
    }
    if(this.data?.view){
      this.form.disable();
    }

  } 

  ngOnInit(): void {
    
  }

  private buildForm(){
    this.form = this.fb.group({
          id: new FormControl(0),
          name: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
          isEnabled: new FormControl(true)
    })
  }

  Accept() {
   
    const ProfessionalProfilesModel = this.form?.value as ProfessionalProfiles;
    
    if(this.form.invalid) {
      this.form.markAllAsTouched();
      this._toastService.error("Por favor, complete todos los campos requeridos.");
      return;
    }
    
    if(this.data.mode == 'add' || this.data.mode == 'edit'){         
      this.save(ProfessionalProfilesModel);  
    }else if(this.data.mode == 'delete'){
      this.delete(ProfessionalProfilesModel.id);
    }
  }
  save(ProfessionalProfilesModel: ProfessionalProfiles) {    
  this.ProfessionalProfilesService.addProfessional(ProfessionalProfilesModel).subscribe({
    next: (res: any) => {
      if (!res) {
        this._toastService.error("Ha ocurrido un error inesperado");
        return;
      }
      this._toastService.success("Datos guardados");
      this.closeDialog();
    },
    error: (error: any) => {
      
      if (error.status === 400 && error.error?.detail) {
        // Error de validación enviado desde el backend
        this._toastService.error(error.error.detail);
      } 
      else if(error.error?.detail){
        this._toastService.error(error.error.detail);
      }
      else if(!error.isArray){
        this._toastService.error(error);
      }
      else {
        // Otros errores (500, etc.)
        this._toastService.error('Ha ocurrido un error inesperado');
      }
    }
  });
}

  delete(id: number){    
    this.ProfessionalProfilesService.deleteProfessional(id).subscribe({
      next: (res:any) => {
        if(!res){this._toastService.error("Ha ocurrido un error inesperado"); return}        
        this._toastService.success("Datos eliminados correctamente!")
        this.closeDialog()
      }, error: (error: any) => {this._toastService.error('Ha ocurrido un error inesperado')}
    })
  }

  closeDialog(): void {
    this.dialogRef.close(true);
  }

}
